(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');
    const { 
        fetchHTML, 
        $isEmpty, 
        $show, 
        $clone 
    } = await importModule('Utils');

    const RQ_SECTION_ID = 'r_cart-notification-product-recommendations';

    const CN_ADDED_ITEMS = '@added-items:'

    const PARAM_IMG_SIZE = 150;

    const SEL_PRODUCT_IMAGE         = '[data-product-image]';
    const SEL_PRODUCT_LINK          = '[data-product-link]';
    const SEL_PRODUCTS              = '[data-products]';
    const SEL_PRODUCT_TITLE         = '[data-product-title]';
    const SEL_PRODUCT_VARIANT_TITLE = '[data-product-variant-title]';
    const SEL_CART_ITEMS_COUNT      = '[data-cart-items-count]';
    const SEL_CART_TOTAL            = '[data-cart-total]';
    const SEL_REC_PRODUCTS          = '[data-recommendation-products]';
    const SEL_REC_CONTAINER         = '[data-recommendation-container]';
    const CART_LEAD_TIME = '[data-cart-lead-time]'; 
    const CART_LEAD_THRESHOLD = '[data-cart-threshold]'; 

    const CN_SHOW = '!show';

  

    customElements.define('cart-notification', class extends Core {
        
        subscriptions = {
            'cart:update':  '_cartUpdateHandler',
            'cart:error':   '_cartErrorHandler',
            'cart-notification:preview-add': '_previewAddHandler'
        }

        elements = {
            template: '[data-template]',
            productTemplate: '[data-product-template]'
        }

        _cartUpdateDebounce = null
        _isProcessing = false

        render() {
            this.subscribe('cart:update', { global: true });
            this.subscribe('cart:error', { global: true });
            this.subscribe('cart-notification:preview-add', { global: true });
        }

        _previewAddHandler(data) {
            this._pendingPreview = data?.items || null;
        }

        _cartErrorHandler() {
            this._pendingPreview = null;
        }

        _cartUpdateHandler(data) {
            if (this._srcIsCart(data.src)) return;
            if (this._isProcessing) {
                this._pendingPreview = null;
                return;
            }
            clearTimeout(this._cartUpdateDebounce);
            this._cartUpdateDebounce = setTimeout(() => {
                void this._flushCartNotification(data);
            }, 100);
        }

        async _flushCartNotification(data) {
            if (this._srcIsCart(data.src)) return;
            if (this._isProcessing) return;
            this._isProcessing = true;
            try {
                await this
                    ._setData(data)
                    ._initContainer()
                    ._setContent()
                    ._setRecommendations();
                
                this._openModal();
            } finally {
                setTimeout(() => {
                    this._isProcessing = false;
                }, 300);
            }
        }

        _srcIsCart(src) {
            return src.toLowerCase().includes('cart-qty');
        }

        _setContent() {
            this._setProducts()
                ._setSubtitle()
                ._setCart();
            return this;
        }

        async _setRecommendations() {
            const $doc = await fetchHTML(`/recommendations/products?${new URLSearchParams({
                product_id: this.recProductId,
                limit: 20,
                section_id: RQ_SECTION_ID
            })}`);

            const $section = $doc.getElementById(`shopify-section-${RQ_SECTION_ID}`);

            if(!$isEmpty($section)) {
                this.$container
                    .querySelector(SEL_REC_PRODUCTS)
                    .replaceChildren(...$section.cloneNode(true).childNodes);

                $show(
                    this.$container
                        .querySelector(SEL_REC_CONTAINER)
                );

                setTimeout(() => {
                const recommendationsContainer = document.querySelector('cart-notification-recommendations');
                const offset =  parseFloat(getComputedStyle(recommendationsContainer.querySelector('[data-spacer]')).paddingRight);
                const swiperProps = {
                spaceBetween: 10,
                slidesOffsetBefore: offset,
                slidesOffsetAfter: offset,
                breakpoints: {
                    1: {
                        slidesPerView: 1.3
                    },
                    992: {
                        slidesPerView: 2.3
                    }
                },
                navigation: {
                    nextEl: recommendationsContainer.querySelector('[data-nav-next]'),
                    prevEl: recommendationsContainer.querySelector('[data-nav-prev]'),
                    disabledClass: '!disabled'
                },
                on: {
                    afterInit: () => {
                        recommendationsContainer.classList.add(CN_SHOW)
                    }
                }
              }
  
              const swiper = new Swiper(recommendationsContainer.querySelector('[data-swiper]'), swiperProps);
              },600);

                
            }
            return this;
        }
        
        _openModal() {
            this.publish('modal:open', {
                content: this.$container,
                close: false,
                animation: 'top',
                positionY: 'top'
            })

            return this;
        }

        _setData(data) {
            this.addedProducts = data.items;
            this.cartItems = data.getItemCount();
            this.cartTotal = data.getSubtotal();
            this.itemLeadTime = data.getLeadTimeBlock();
            this.recProductId = data.items[0]['product_id'];
           // this.itemThreshold = data.getThresholdBlock();

            if (this._pendingPreview?.length) {
                this.addedProducts = [...this.addedProducts, ...this._pendingPreview];
                const parsed = parseInt(this.cartItems, 10);
                if (!isNaN(parsed)) {
                    const newNum = parsed + this._pendingPreview.length;
                    const withWord = this.cartItems.match(/^(.*?)(\d+)(\s+)(\w+?)(s?)(\b.*)$/);
                    if (withWord) {
                        const [, before, , sp, word, , after] = withWord;
                        this.cartItems = `${before}${newNum}${sp}${word}${newNum === 1 ? '' : 's'}${after}`;
                    } else {
                        this.cartItems = this.cartItems.replace(/\d+/, String(newNum));
                    }
                }
                this._pendingPreview = null;
            }

            return this;
        }

        _initContainer() {
            this.$container = $clone(this.$template);

            // Adding number of products css class (only for styling)
            this.$container
                .firstElementChild
                .classList
                .add(CN_ADDED_ITEMS + this.addedProducts.length);

            return this;
        }

        _setProducts() {
            this.$container
                .querySelector(SEL_PRODUCTS)
                .replaceChildren(
                    ...this.addedProducts.map(
                        this._setProduct.bind(this)
                    )
                );
            
            return this;
        }

        _setSubtitle() {
            const [{ 
                variant_id: variantId,
                product_title: productTitle, 
                variant_title: variantTitle,
                selling_plan_allocation: sellingPlanAllocation
             }] = this.addedProducts;
            
            this.$container
                .querySelector(SEL_PRODUCT_TITLE)
                .textContent = productTitle;
            
            if(variantTitle) {
                this.$container
                    .querySelector(SEL_PRODUCT_VARIANT_TITLE)
                    .textContent = variantTitle;
            }

             if(variantId && this.itemLeadTime) {
               if(this.itemLeadTime.getAttribute("data-variant-id") == variantId){
                this.$container
                .querySelector(CART_LEAD_TIME)
                .textContent = this.itemLeadTime.innerHTML.replace("Out of stock!","");         
               }
            }

            //  if(this.itemThreshold) {             
            //     this.$container
            //     .querySelector(CART_LEAD_THRESHOLD)
            //     .innerHTML = this.itemThreshold.innerHTML;         
            // }
          
            
            return this;
        }

        _setProduct({
            image,
            url,
            isPreview
        }) {
            const $productContainer = $clone(this.$productTemplate);

            $productContainer
                .querySelector(SEL_PRODUCT_IMAGE)
                .src = isPreview ? image : this._getOptimizedImage(image);

            $productContainer
                .querySelector(SEL_PRODUCT_LINK)
                .href = url;

            return $productContainer;
        }

        _getOptimizedImage(imgSrc) {
            const imgFormat = imgSrc.includes('.jpg') ? '.jpg' : '.png';
            return imgSrc.replace(imgFormat, `_${PARAM_IMG_SIZE}x${imgFormat}`)
        }

        _setCart() {
            this.$container
                .querySelector(SEL_CART_ITEMS_COUNT)
                .textContent = this.cartItems;
            
            this.$container
                .querySelector(SEL_CART_TOTAL)
                .textContent = this.cartTotal;

             

            return this;
        }
    })
})();